export default "__VITE_ASSET__Cg_I6zCv__"